import { DEFAULT_ATTRIBUTES } from 'shared/api/query/constants';
import { favorite } from 'shared/api/query/configs.json';

export const children = [
  ...DEFAULT_ATTRIBUTES,
  { attr: favorite.edges.title, default: '' },
  { attr: favorite.edges.emoji, default: '' },
  { attr: favorite.edges.routeName },
  { attr: favorite.edges.query, default: null },
  { attr: favorite.edges.params, default: null },
];
